import { AliexpressProductResponse } from "./AliexpressProduct.types";


export function getAliexpressVariationQuickData(
  variationData: AliexpressProductResponse['aliexpress_ds_product_get_response']['result']['ae_item_sku_info_dtos']['ae_item_sku_info_d_t_o'][number]
): {
  skuId: string;
  skuImages: string[];
} {
  return {
    skuId: variationData.sku_id,
    skuImages: variationData.ae_sku_property_dtos.ae_sku_property_d_t_o
      .map(property => property.sku_image)
      .filter((image): image is string => image !== undefined),
  }
}

export function getAliexpressProductQuickData(
  productData: AliexpressProductResponse['aliexpress_ds_product_get_response']['result']
): {
  externalProductId: string;
  store: {
    externalStoreId: string;
    name: string;
    country: string;
    rating: number;
    communicationRating: number;
    shippingSpeedRating: number;
    itemAsDescribedRating: number;
  }
} {
  return {
    externalProductId: productData.data.ae_item_base_info_dto.product_id.toString(),
    store: {
      externalStoreId: productData.data.ae_store_info.store_id.toString(),
      name: productData.data.ae_store_info.store_name,
      country: productData.data.ae_store_info.store_country_code,
      rating: parseFloat(productData.data.ae_store_info.item_as_described_rating),
      communicationRating: parseFloat(productData.data.ae_store_info.communication_rating),
      shippingSpeedRating: parseFloat(productData.data.ae_store_info.shipping_speed_rating),
      itemAsDescribedRating: parseFloat(productData.data.ae_store_info.item_as_described_rating),
    }
  }
}